(ns hypnos.sleeplab.subs
  "Subscriptions for the sleeplab application."
  (:require [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Auth

(rf/reg-sub
 :sleeplab/auth
 (fn [db [_]]
   (get-in db [:auth])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; UI

(rf/reg-sub
 :sleeplab/active-panel
 (fn [db _]
   (get-in db [:ui :active-panel])))

(rf/reg-sub
 :sleeplab/aside
 (fn [db _]
   (get-in db [:ui :aside])))

(rf/reg-sub
 :sleeplab/gql-request-in-progress?
 (fn [db _]
   (get-in db [:ui :loading?])))

(rf/reg-sub
 :sleeplab/communication
 (fn [db _]
   (get-in db [:communication])))

(rf/reg-sub
 :sleeplab/error
 (fn [db _]
   (get-in db [:error])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Catalog

(rf/reg-sub
 :sleeplab/catalog
 (fn [db _]
   (get-in db [:catalog])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Consult(s)

(rf/reg-sub
 :sleeplab/consults
 (fn [db _]
   (get-in db [:consults])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Patient(s)

(rf/reg-sub
 :sleeplab/patients-query
 (fn [db _]
   (get-in db [:patients :query])))

(rf/reg-sub
 :sleeplab/patient
 (fn [db _]
   (get-in db [:patient])))

(rf/reg-sub
 :sleeplab/patients
 (fn [db _]
   (get-in db [:patients])))

(rf/reg-sub
 :sleeplab/recommendations-with-note
 (fn [db _]
   (get-in db [:recommendations-with-note])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Organization

(rf/reg-sub
 :sleeplab/organization
 (fn [db _]
   (get-in db [:organization])))

(rf/reg-sub
 :sleeplab/user
 (fn [db [_]]
   (get-in db [:auth :user])))
